const ACCEPT_COOKIES_EXPIRY_DAYS = 365
const ACCEPT_COOKIES_KEY = 'accept_cookies'

export function cookiesAllowed (appState = null) {
  return window.Capacitor?.isNative ||
    appState?.get('role') === 'embed' ||
    appState?.get('user')?.isLoggedIn() ||
    cookiesAccepted()
}

export function acceptCookies () {
  const expiry = 1000 * 24 * 60 * 60 * ACCEPT_COOKIES_EXPIRY_DAYS
  const expires = new Date()
  expires.setTime(expires.getTime() + expiry)
  document.cookie =
    `${ACCEPT_COOKIES_KEY}=1;domain=${domain()};expires=${expires.toUTCString()};path=/`
}

export function clearCookies () {
  document.cookie.split(';')
    .forEach(cookie => {
      const key = cookie.split('=')[0]
      document.cookie = `${key}=; expires = Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain()}; path=/`
    })
}

const cookiesAccepted = () => document.cookie.includes(`${ACCEPT_COOKIES_KEY}=1`)

const domain = () => location.hostname.split('.').slice(-2).join('.')
